// extracted by mini-css-extract-plugin
export var captchaPuzzle = "CaptchaPuzzleModal-module--captchaPuzzle--1e94c";
export var invisible = "CaptchaPuzzleModal-module--invisible--34a34";
export var visible = "CaptchaPuzzleModal-module--visible--f9d2e";